import { render, staticRenderFns } from "./upload_img.vue?vue&type=template&id=ceabe8bc&scoped=true&"
import script from "./upload_img.vue?vue&type=script&lang=js&"
export * from "./upload_img.vue?vue&type=script&lang=js&"
import style0 from "./upload_img.vue?vue&type=style&index=0&id=ceabe8bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceabe8bc",
  null
  
)

export default component.exports